import React from 'react';
import { Row, Col, Glyphicon, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getManifestById, getIsFetching, loadManifest } from '../duck';
import ManifestsTable from '../manifestsList/components/ManifestsTable';
import ManifestTimeline from '../../../components/ManifestTimeline';
import RecoveryActionsListSimple from './components/RecoveryActionsListSimple';
import AbnormalitiesListSimple from './components/AbnormalitiesListSimple';
import KanbanMatrix from './components/KanbanMatrix';
import { createManifestDetailBreadcrumb } from '../../../shared/utils/breadcrumbs';

class Manifest extends React.Component {
    componentWillMount() {
        this.props.loadManifest(this.props.params.id);
    }

    handleCreateGenericClick = () => {
        const { router, manifest } = this.props;
        router.push({
            pathname: `/manifests/${manifest.manifestId}/abnormality/GENERIC`,
            query: { manifestNumber: manifest.manifestNumber },
        });
    };

    render() {
        const { isFetching, manifest } = this.props;

        if (isFetching || !manifest) {
            return <p className="text-center">Loading manifest...</p>;
        }

        return (
            <div>
                {createManifestDetailBreadcrumb(manifest)}
                <Row>
                    <Col xs={12}>
                        <h3>Manifest</h3>
                        <ManifestsTable
                            manifests={[manifest]}
                            isPaginated={false}
                            noManifestLink={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <h3>Timeline</h3>
                        {manifest.runs &&
                            manifest.partOfSpecial && (
                                <Alert>
                                    <Glyphicon glyph="info-sign" className="text-primary" /> This
                                    manifest contains a special recovery action. Be aware that the
                                    timeline may look differently than expected.
                                </Alert>
                            )}
                        {manifest.runs && <ManifestTimeline plannedRun={manifest.runs} />}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={4}>
                        <h3>Kanban matrix</h3>
                        <KanbanMatrix kanbans={manifest.kanbans} />
                    </Col>
                    <Col xs={12} lg={4}>
                        <h3>Abnormalities</h3>
                        <AbnormalitiesListSimple
                            abnormalities={manifest.abnormalities}
                            handleCreateGenericClick={this.handleCreateGenericClick}
                        />
                    </Col>
                    <Col xs={12} lg={4}>
                        <h3>Recovery actions</h3>
                        <RecoveryActionsListSimple recoveryActions={manifest.recoveryActions} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        manifest: getManifestById(state, ownProps.params.id),
        isFetching: getIsFetching(state),
    }),
    { loadManifest, getIsFetching }
)(Manifest);
